import { Dates } from "src/modules/utils/shared/dates";
import { Arrays } from "../shared/arrays";
import { Comparable } from "../shared/comparable";
import { Objects } from "../shared/objects";
import { Strings } from "../shared/strings";

export class UserInteractionItem implements Comparable<UserInteractionItem> {
    constructor(public date: Date, public type: string, public texts: string[]) {
    }

    compareTo(other: UserInteractionItem): number {
        return Objects.cmp(this.date, other.date);
    }

    toString(): string {
        return Dates.formatDefault(this.date) + ": " + this.type.padEnd(10) + " " + Arrays.itemsToString(Arrays.mapWithIndex(this.texts, (text, index) => (index == 0 ? "" : "                                ") + text), "\r\n");
    }
}